const locationsFilterOptions = {
  All: 'all',
  Active: 'active',
  inActive: 'inactive',
}

export default locationsFilterOptions
